<div class="carousel-container">
    <div class="carousel">
        <button class="nav-arrow nav-prev" (click)="prev()" [disabled]="!hasPrev() || loading()" title="Previous"
            aria-label="Previous">
            <ng-icon name="iconoirNavArrowLeft" size="24"></ng-icon>
        </button>

        <div class="carousel-content">
            @if(loading()) {
            <p class="carousel-title carousel-subtitle-skeleton">placeholder</p>
            <div class="carousel-image-container" [ngStyle]="{ 'aspect-ratio': aspectRatioSet() ? aspectRatio() : null }" [class.not-clickable]="true">
                <div class="carousel-skeleton"></div>
            </div>
             <p class="carousel-title carousel-subtitle-skeleton">placeholder</p>
            <!-- <div class="carousel-subtitle-skeleton"></div> -->
            } @else {
            @if(currentItem(); as item) {
            @if(slideContentTemplate) {
            <ng-container
                *ngTemplateOutlet="slideContentTemplate; context: { $implicit: item, index: currentIndex() }"></ng-container>
            } @else {
            @if(item.title) {
            <p class="carousel-title">{{ item.title }}</p>
            }
            <div #carouselContainer [ngStyle]="{ 'aspect-ratio': aspectRatioSet() ? aspectRatio() : null }" class="carousel-image-container" (click)="openPreview()" [class.not-clickable]="imageLoading()">
                @if(imageLoading()) {
                <div class="carousel-skeleton"></div>
                }
                <img [src]="getImageUrl(item)" [alt]="item.title || 'Slide ' + (currentIndex() + 1)"
                    [title]="showPreview() && !imageLoading() ? 'Click to preview' : (item.title || 'Slide ' + (currentIndex() + 1))"
                    class="carousel-image" [class.clickable]="showPreview() && !imageLoading()"
                    [class.hidden]="imageLoading()" loading="lazy" (load)="onImageLoad()"
                    (error)="onImageError($event)" />
            </div>
            @if(slideInfoTemplate) {
            <ng-container
                *ngTemplateOutlet="slideInfoTemplate; context: { $implicit: item, index: currentIndex() }"></ng-container>
            } @else if(item.subtitle) {
            <p class="carousel-subtitle">{{ item.subtitle }}</p>
            }
            }
            } @else if(totalItems() === 0) {
            <div class="carousel-placeholder">
                <span>{{ emptyMessage() }}</span>
            </div>
            }
            }
        </div>

        <button class="nav-arrow nav-next" (click)="next()" [disabled]="!hasNext() || loading()" title="Next"
            aria-label="Next">
            <ng-icon name="iconoirNavArrowRight" size="24"></ng-icon>
        </button>
    </div>

    <!-- Indicators -->
    @if(showIndicators()) {
    <div class="carousel-indicators">
        @if(loading()) {
        <span class="indicator-skeleton"></span>
        <span class="indicator-skeleton"></span>
        <span class="indicator-skeleton"></span>
        } @else if(totalItems() > 0) {
        @for(item of items(); track item.id; let i = $index) {
        <button class="indicator" [class.active]="i === currentIndex()" (click)="goTo(i)"
            [title]="item.title || 'Slide ' + (i + 1)" [attr.aria-label]="'Go to slide ' + (i + 1)">
        </button>
        }
        }
    </div>
    }
</div>

<!-- Preview Modal -->
@if(previewOpen() && currentItem(); as item) {
<div class="preview-overlay" (click)="closePreview()">
    <div class="preview-modal" (click)="$event.stopPropagation()">
        <button class="preview-close" (click)="closePreview()" title="Close preview" aria-label="Close preview">
            <ng-icon name="iconoirXmark" size="24"></ng-icon>
        </button>

        <div class="preview-content">
            <button class="preview-nav prev" (click)="prev()" [disabled]="!hasPrev()" title="Previous"
                aria-label="Previous">
                <ng-icon name="iconoirNavArrowLeft" size="32"></ng-icon>
            </button>

            <div class="preview-image-container">
                @if(previewImageLoading()) {
                <div class="preview-skeleton"></div>
                }
                <img [src]="getImageUrl(item)" [alt]="item.title || 'Slide ' + (currentIndex() + 1)"
                    [title]="item.title || 'Slide ' + (currentIndex() + 1)" class="preview-image"
                    [class.hidden]="previewImageLoading()" loading="lazy" (load)="onPreviewImageLoad()"
                    (error)="onPreviewImageError($event)" />
                @if(item.title || item.subtitle) {
                <div class="preview-info">
                    @if(item.title) {
                    <span class="preview-title">{{ item.title }}</span>
                    }
                    @if(item.subtitle) {
                    <span class="preview-subtitle">{{ item.subtitle }}</span>
                    }
                </div>
                }
            </div>

            <button class="preview-nav next" (click)="next()" [disabled]="!hasNext()" title="Next" aria-label="Next">
                <ng-icon name="iconoirNavArrowRight" size="32"></ng-icon>
            </button>
        </div>

        <div class="preview-counter">
            {{ currentIndex() + 1 }} / {{ totalItems() }}
        </div>
    </div>
</div>
}